import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from 'react';
import Alert from '@mui/material/Alert';
import hasRole from '../helpers/hasRole';
import UserContext from '../contexts/userContext';
var UserRoleCheck = function (_a) {
    var children = _a.children, roles = _a.roles, showError = _a.showError;
    var user = useContext(UserContext).user;
    if (!user || !roles.some(function (role) { return hasRole(user, role); })) {
        if (showError) {
            return _jsx(Alert, { severity: "error", children: "You don't have permissions to see this content" });
        }
        return _jsx(_Fragment, {});
    }
    return _jsx(_Fragment, { children: children });
};
export default UserRoleCheck;
